import { t } from "i18next"

const condition = [
    {
        value: null,
        field: ''
    },
    {
        value: 1,
        field: 'Aktiv'
    },
    {
        Value: 0,
        field: 'Passiv'
    },
]



const YES_OR_NO_DROPDOWN = [
    {
        field: t("Choose"),
        value:  ""
    },
    {
        field: t("Yes"),
        value:  1
    },
    {
        field: t("No"),
        value:  0
    }
]

const LANDING_TYPE_DROPDOWN = [
    {
        field: t("Choose"),
        value:  null
    },
    {
        field: t("Whole"),
      // fieldNorsk: "Hele",
        value:  0
    },
    {
        field: t("Part"),
       // fieldNorsk: "Del",
        value:  1
    },

]


export const DROPDOWN_ITEMS = {
    condition, 
    status:  condition,
    yesOrNo: YES_OR_NO_DROPDOWN,
    landingType: LANDING_TYPE_DROPDOWN
}



/////// -----------Helpers -------//////

export  const getLandingTypeField = (value: number | string) => {
    if(value === null || value === undefined || value === "") return LANDING_TYPE_DROPDOWN[0]

     const type = LANDING_TYPE_DROPDOWN.find(v=> v.value === value)
     if(type ) return type
     
     return LANDING_TYPE_DROPDOWN[0]

}

export  const getYesOrNoField = (value: number | string ) => {
    if(value === null || value === undefined || value === "") return YES_OR_NO_DROPDOWN[0]
     const type = YES_OR_NO_DROPDOWN.find(v=> v.value === parseInt(value as string))
     if(type ) return type
     
     return YES_OR_NO_DROPDOWN[0]

}